var $ = require('jQuery');
var Eventable = require('Eventable');

var Component = function (options) {
    Eventable.call(this);
    this._show = true;
    this._data = {};   
};
Component.prototype = Object.create(Eventable.prototype);
Component.prototype.show = function () {
    this._show = true;
    this._element.show();
};
Component.prototype.hide = function () {
    this._show = false;
    this._element.hide();
};
Component.prototype.getElement = function () {
    return this._element;
};
Component.prototype.setData = function (data) {
    $.extend(this._data, data);
    this.render();
};
Component.prototype.render = function () {
};
Component.prototype.destroy = function () {
    $.each(this._children, function (key, value) {
        value && value.destroy();
    });
    this._children = {};
    this._element.remove();
    this._element = null;
    this._data = null;
    this._options = null;
};
Component.prototype.before = function (target) {
    if (target instanceof Component === false) {
        return
    }
    this._element.before(target.getElement());
};
Component.prototype.after = function (target) {
    if (target instanceof Component === false) {
        return
    }
    this._element.after(target.getElement());
};
Component.prototype.width = function () {
    return this._element.outerWidth();
};
Component.prototype.height = function () {
    return this._element.outerHeight();
};

module.exports = Component;
